/**
 * assets/main-product.js
 *
 * Stage 1 fix (plan Sec.4.9): the LIVE asset at this key was not valid
 * JavaScript. It was a line-numbered debug-extraction dump of HTML/inline
 * script excerpts (e.g. "L3250: id=... " style lines), not executable
 * code. Confirmed via a direct read-only get_asset call against the live
 * theme and via the CDN public_url, which returned Shopify's own
 * "Minification failed" banner. This is a genuine, separate defect from
 * anything described in the source plan (which assumed a hardcoded
 * "£22.99" price string; no such string exists anywhere in the pulled
 * live content).
 *
 * This file is loaded `defer`, after the inline <script> block that
 * sections/main-product.liquid already ships (which defines kbPack,
 * kbPlan, kbUpdatePrices, kbSyncCart, kbStickySync and the pack/plan/
 * flavour/variant wiring, and works correctly on its own). A code
 * comment inside that inline script explains this file historically
 * re-declared kbPack/kbPlan/kbUpdatePrices "with versions that lack
 * kbSyncCart", which is why the inline script defensively re-wraps
 * kbUpdatePrices on window 'load'.
 *
 * The original (pre-corruption) content of this file could not be
 * recovered, so nothing here is a "restore". Written fresh as a safe,
 * valid, idempotent reinforcement: if the inline script already ran
 * (the normal case), this only re-asserts kbSyncCart so cart state
 * (variant id + selling plan) is always in sync with the visible
 * pack/plan selection. If the inline script were ever missing, this
 * provides the full pack-selector implementation as a fallback so the
 * buy box still works, including kbSyncCart from the start (closing the
 * exact gap the old broken version had).
 */
(function () {
  'use strict';

  function reinforceExisting() {
    if (typeof window.kbSyncCart !== 'function') return false;
    // Re-assert cart sync now that this deferred asset has loaded, and
    // make sure kbUpdatePrices always calls it going forward (idempotent;
    // safe even if the inline script's own wrapper already did this).
    if (typeof window.kbUpdatePrices === 'function' && !window.kbUpdatePrices.__suppsWrapped) {
      var original = window.kbUpdatePrices;
      window.kbUpdatePrices = function () {
        original.apply(this, arguments);
        window.kbSyncCart();
      };
      window.kbUpdatePrices.__suppsWrapped = 1;
    }
    window.kbSyncCart();
    return true;
  }

  function installFallback() {
    // Fallback implementation, only used if the inline pack-selector
    // script did not run for some reason. Mirrors that script exactly,
    // with kbSyncCart wired in from the start.
    var kbPrices = {
      1: { subCompare: '£26.99', subPrice: '£21.00', subFreq: 'Deliver Every Month', oneCompare: '£26.99', onePrice: '£24.95' },
      2: { subCompare: '£53.98', subPrice: '£39.90', subFreq: 'Deliver Every 2 Months', oneCompare: '£53.98', onePrice: '£45.00' },
      3: { subCompare: '£80.97', subPrice: '£54.00', subFreq: 'Deliver Every 3 Months', oneCompare: '£80.97', onePrice: '£65.00' }
    };
    var kbCurrentPack = 2;
    var kbCurrentPlan = 'one';

    var KB_VARIANTS = {
      1: { berry: 52394864869705, pineapple: 54727556923721 },
      2: { berry: 54727561871689, pineapple: 54727561937225 },
      3: { berry: 54727561904457, pineapple: 54727561969993 }
    };
    var KB_PLANS = { 1: 692335477065, 2: 692335509833, 3: 692335542601 };

    function kbCurrentFlavour() {
      var fl = document.getElementById('kb-fl' + kbCurrentPack);
      var sel = fl && fl.querySelector('.kb-flavour-select');
      var txt = sel ? (sel.value || (sel.options[sel.selectedIndex] && sel.options[sel.selectedIndex].text) || '') : '';
      return /pineapple/i.test(txt) ? 'pineapple' : 'berry';
    }

    function kbSyncCart() {
      var pack = KB_VARIANTS[kbCurrentPack] || KB_VARIANTS[2];
      var vid = pack[kbCurrentFlavour()] || pack.berry;
      var idInput = document.querySelector('.product-variant-id, input[name="id"]');
      if (idInput) idInput.value = vid;
          if (idInput && !document.getElementById('kb-preorder-prop')) { var _pp = document.createElement('input'); _pp.type = 'hidden'; _pp.id = 'kb-preorder-prop'; _pp.name = 'properties[Pre-order]'; _pp.value = 'ships by 1 Dec'; idInput.parentNode.insertBefore(_pp, idInput.nextSibling); }
      var sp = document.getElementById('kb-selling-plan');
      if (!sp && idInput) {
        sp = document.createElement('input');
        sp.type = 'hidden';
        sp.name = 'selling_plan';
        sp.id = 'kb-selling-plan';
        idInput.parentNode.insertBefore(sp, idInput.nextSibling);
      }
      if (sp) {
        if (kbCurrentPlan === 'sub') {
          sp.value = KB_PLANS[kbCurrentPack] || '';
          sp.disabled = false;
        } else {
          sp.value = '';
          sp.disabled = true; // disabled inputs are not posted, so one-time
        }
      }
      var os = document.getElementById('kb-one-ship');
      if (os) os.textContent = (kbCurrentPack >= 2) ? 'Free Shipping' : '£2.99 Shipping';
    }

    function kbUpdatePrices() {
      var d = kbPrices[kbCurrentPack];
      var subCompareEl = document.getElementById('kb-sub-compare');
      var subPriceEl = document.getElementById('kb-sub-price');
      var subFreqEl = document.getElementById('kb-sub-freq');
      var oneCompareEl = document.getElementById('kb-one-compare');
      var onePriceEl = document.getElementById('kb-one-price');
      if (subCompareEl) subCompareEl.textContent = d.subCompare;
      if (subPriceEl) subPriceEl.textContent = d.subPrice;
      if (subFreqEl) subFreqEl.textContent = d.subFreq;
      if (oneCompareEl) oneCompareEl.textContent = d.oneCompare;
      if (onePriceEl) onePriceEl.textContent = d.onePrice;
      var mainPrice = kbCurrentPlan === 'sub' ? d.subPrice : d.onePrice;
      var el = document.querySelector('.product__price-supps');
      if (el) el.textContent = mainPrice;
      if (typeof window.kbStickySync === 'function') window.kbStickySync();
      kbSyncCart();
    }

    function kbPack(n) {
      [1, 2, 3].forEach(function (i) {
        var el = document.getElementById('kb-p' + i);
        if (el) el.classList.toggle('kb-pack--sel', i === n);
      });
      ['kb-fl1', 'kb-fl2', 'kb-fl3'].forEach(function (id) {
        var el = document.getElementById(id);
        if (el) el.style.display = 'none';
      });
      var fl = document.getElementById('kb-fl' + n);
      if (fl) fl.style.display = '';
      kbCurrentPack = n;
      kbUpdatePrices();
    }

    function kbPlan(p) {
      var sub = document.getElementById('kb-sub');
      var one = document.getElementById('kb-one');
      if (sub) sub.classList.toggle('kb-plan--sel', p === 'sub');
      if (one) one.classList.toggle('kb-plan--sel', p === 'one');
      kbCurrentPlan = p;
      kbUpdatePrices();
    }

    window.kbPrices = kbPrices;
    window.kbPack = kbPack;
    window.kbPlan = kbPlan;
    window.kbUpdatePrices = kbUpdatePrices;
    window.kbSyncCart = kbSyncCart;

    var s = document.querySelectorAll('.kb-flavour-select');
    for (var i = 0; i < s.length; i++) s[i].addEventListener('change', kbSyncCart);
    var pf = document.getElementById('product-form-template--28705556463950__main');
    if (pf) pf.addEventListener('submit', kbSyncCart, true);
    kbSyncCart();
  }

  function run() {
    if (!reinforceExisting()) installFallback();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();


/**
 * Gallery thumbnail fix (2026-07-06): clicking a thumbnail did nothing --
 * the actual image never changed on either the product page or the
 * homepage's embedded product gallery. Root cause: Dawn's native
 * slider-component (registered and working) expects thumbnail links to be
 * <a href="#Slide-..."> anchors so its own linkToSlide() can scroll to the
 * right slide, but this theme's thumbnails are plain <button> elements with
 * no href, so that native wiring never engages. Nothing else in this theme
 * (main-product.js, global-script.js) was wiring thumbnail clicks at all.
 *
 * Fix: for every media-gallery on the page, scroll its real slider
 * container to the clicked thumbnail's matching slide, using the slide's
 * actual offsetLeft rather than scrollIntoView (unreliable in this theme's
 * peek-style horizontal slider). Verified working via direct browser testing
 * before this was written.
 */
(function () {
  function wireGallery(gallery) {
    var slider = gallery.querySelector('.product__media-list.slider') || gallery.querySelector('.slider');
    var slides = Array.prototype.slice.call(gallery.querySelectorAll('.product__media-list > .product__media-item'));
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('.thumbnail-list__item'));
    if (!slider || slides.length < 2 || !thumbs.length) return;

    var allButtons = thumbs.map(function (t) { return t.querySelector('button.thumbnail'); }).filter(Boolean);

    thumbs.forEach(function (t) {
      var btn = t.querySelector('button.thumbnail');
      var id = t.getAttribute('data-target');
      if (!btn || !id) return;
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var target = slides.filter(function (s) { return s.getAttribute('data-media-id') === id; })[0];
        if (target) slider.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
        allButtons.forEach(function (b) { b.removeAttribute('aria-current'); });
        btn.setAttribute('aria-current', 'true');
      });
    });
  }

  function init() {
    document.querySelectorAll('media-gallery').forEach(wireGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();


/**
 * Pineapple "coming soon" badge (2026-07-07): a small pink corner badge
 * overlaid on every rendered Pineapple Power image (gallery slide,
 * thumbnail, and zoom modal), on both the PDP and the homepage embed
 * (this file loads site-wide via theme.liquid, so no extra wiring needed
 * for the homepage). Pure visual overlay only -- it never moves, reorders,
 * resizes, or touches the image element or its container's contents in
 * any other way, specifically because a prior attempt at this caused the
 * product images to shift into the wrong slots.
 */
(function () {
  function injectStyleOnce() {
    if (document.getElementById('kb-coming-soon-style')) return;
    var style = document.createElement('style');
    style.id = 'kb-coming-soon-style';
    style.textContent = '.kb-coming-soon-badge{position:absolute;' +
      'background:#E91E63;color:#fff;font-family:"Archivo",sans-serif;font-size:9px;' +
      'font-weight:800;letter-spacing:.04em;padding:3px 7px;border-radius:12px;' +
      'text-transform:uppercase;z-index:5;pointer-events:none;white-space:nowrap;width:auto!important;height:auto!important;max-width:max-content!important;max-height:none!important;display:inline-block!important;box-sizing:content-box!important}';
    document.head.appendChild(style);
  }

  function addBadge(img, corner) {
    if (img.dataset.kbComingSoonBadged) return;
    var parent = img.parentElement;
    if (!parent) return;
    img.dataset.kbComingSoonBadged = '1';
    var cs = window.getComputedStyle(parent);
    if (cs.position === 'static') parent.style.position = 'relative';
    var badge = document.createElement('span');
    badge.className = 'kb-coming-soon-badge';
    badge.textContent = 'Coming Soon';
    parent.appendChild(badge);
    if (corner === 'right') {
      // sits lower, over the pineapple pouch photo itself -- the composite
      // image has a header title band across the top, so a fixed 6px from
      // the top would land on that text instead of the product photo.
      badge.style.top = (img.offsetTop + img.offsetHeight * 0.32) + 'px';
      var rightPos = (parent.offsetWidth - img.offsetLeft - img.offsetWidth) + 6;
      badge.style.left = 'auto';
      badge.style.right = rightPos + 'px';
    } else {
      badge.style.top = (img.offsetTop + 6) + 'px';
      badge.style.right = 'auto';
      badge.style.left = (img.offsetLeft + 6) + 'px';
    }
  }

  var kbBadgeRan = false;
  function run() {
    if (kbBadgeRan) return;
    kbBadgeRan = true;
    injectStyleOnce();
    // Solo Pineapple Power pouch shots: Frame_391.webp (main product shot,
    // used across the gallery + thumbnail + zoom modal) and c.webp (a second,
    // separate solo pouch photo that closes out the gallery -- different file,
    // generic filename/alt, so it needs its own explicit match).
    var solo = document.querySelectorAll('img[alt*="Pineapple" i], img[src*="Frame_391"], img[src*="c.webp"]');
    solo.forEach(function (img) { addBadge(img, 'left'); });
    // Group_268.webp is the "2 Bold, Fruity Flavours" composite showing both
    // pouches side by side (Pineapple Power on the right) -- badge only the
    // right half so it doesn't imply Berry Blast is also coming soon, and
    // only the large main-slide rendering of it, not the small thumbnail.
    var composite = document.querySelectorAll('img[src*="Group_268"]');
    composite.forEach(function (img) {
      if (img.closest('.thumbnail-list__item')) return;
      addBadge(img, 'right');
    });
  }

  function schedule() {
    if ('requestIdleCallback' in window) {
      requestIdleCallback(run, { timeout: 2000 });
    } else {
      setTimeout(run, 1500);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }
  window.addEventListener('load', schedule);
})();
